import React from 'react';
import styled from 'styled-components';
import {Star, StarBorder} from '@mui/icons-material';
import {SIZES} from '@fupa/fupa-uikit';
import {useFollow} from 'app/hooks/useFollow';
import {IconButton} from '@mui/material';

const FollowWrapper = styled.div`
  width: ${SIZES[40]};
  height: inherit;
  margin-right: ${SIZES[16]};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const SearchFollowButton = ({entity}) => {
  const {isFollowed, toggleFollow} = useFollow(entity, null, true, 'search');

  return (
    <FollowWrapper onClick={toggleFollow}>
      <IconButton size='large'>{isFollowed ? <Star color='secondary' /> : <StarBorder color='action' />}</IconButton>
    </FollowWrapper>
  );
};
